export const pageTitle = (title) => {
  return ( document.title = title + " - > NABCO - National Association of Black County Officials");
}